export class Email {
    emailFrom: string;
    assunto: string;
    mensagem: string;
}